import React from 'react'
import Content from '../@react-fefmwk/theme-structure/modules/Content'

import {idFromToken,displaynameFromToken} from '../@react-fefmwk/auth/services/token'

import UserWelcome from '../modules/UserWelcome'
import MyDashboard from '../modules/MyDashboard'

import { Box, Typography } from '@material-ui/core'

class HomePage extends React.Component {
    render() {
        const title = this.props.route.title

        const id_user = idFromToken()
        const dispaly_name = displaynameFromToken()

        return <Content title={title}>
            <Box mt={2}>
                <Typography component="h1" variant="h4">
                    Area riservata
                </Typography>
            </Box>
            <Box mt={1} mb={2}>
                <UserWelcome id_user={id_user} dispaly_name={dispaly_name} />
            </Box>
            <Box mt={4}>
                <MyDashboard id_user={id_user} />
            </Box>
        </Content>
    }
}

export default HomePage